export const REELS_COUNT = 3;

export const SLOT_SIZE = {
  base: {
    height: 40,
    width: 70
  },
  xs: {
    height: 45,
    width: 80
  },
  sm: {
    height: 73,
    width: 130
  },
  md: {
    height: 84,
    width: 150
  },
  lg: {
    height: 90,
    width: 160
  }
}

export const SLOT_MACHINE_SIZE = {
  base: {
    height: 113,
    width: 330
  },
  sm: {
    height: 183,
    width: 480
  },
  md: {
    height: 210,
    width: 540
  },
  lg: {
    height: 225,
    width: 570
  }
}